export const privacyAndCookiePolicyUrl = '/about/privacy-and-cookie-policy/';
export const googlePartnersUrl = '/about/google-partners/';
